import React from 'react';
import { ENUM_RETURNS_STATUS } from 'models/common.model';
import { RETURNS_STATUS_TAG } from 'utils/constants';

const ReturnsStatusTag = ({ type }: { type: ENUM_RETURNS_STATUS }) => {
  const { bgColor, text, textColor } = RETURNS_STATUS_TAG[type];
  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: textColor
      }}
      className={`flex items-center gap-1 capitalize rounded-[40px] font-medium text-xs leading-[19px] px-3 py-1`}>
      <p
        className='w-[8px] h-[8px] rounded-full'
        style={{
          backgroundColor: textColor
        }}
      />
      {text}
    </div>
  );
};

export default ReturnsStatusTag;
